module.exports = __webpack_public_path__ + "static/media/UpandraRai.057eb6e6.png";